import {EPaymentTab} from './definitions';

export default {
  yourBalance: 'Ваш баланс',
  tab: {
    [EPaymentTab.REPLENISHMENT]: 'Пополнение баланса',
    [EPaymentTab.ACCOUNT_STATEMENT]: 'Выписка по счету',
    [EPaymentTab.DOCUMENTATION]: 'Документы',
  },
};
